import { useLanguage } from "../../../../stores/LanguageStore";
import { useDisclosure } from "@mantine/hooks";
import {
  ActionIcon,
  Anchor,
  Button,
  CopyButton,
  Divider,
  Group,
  LoadingOverlay,
  Modal,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import BackButton from "../../../../components/View/BackButton";
import {
  IconCheck,
  IconCircle,
  IconCircle1,
  IconCircleDot,
  IconCircleDotFilled,
  IconCircleFilled,
  IconCopy,
  IconHistory,
  IconLink,
} from "@tabler/icons-react";
import { useEffect, useMemo, useState } from "react";
import ArgumentsDatabase from "../components/jobs/arguments/ArgumentsDatabase";
import { findList } from "../../../../api/ContactAPI";

const ListUrlUsed = ({ current, closeMenu, inList }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(true);
  const [opened, { open, close }] = useDisclosure();
  const isDatabase =
    current?.state_details[current.state_details.length - 1]?.type ===
    "DatabaseExtractContacts";
  const [urls, setUrls] = useState([]);

  const searchHistory = useMemo(() => {
    return current.state_details.filter(
      (x) => x.type === "DatabaseExtractContacts"
    );
  }, [current.state_details]);

  const handleClose = () => {
    close();
    closeMenu?.();
  };

  useEffect(() => {
    if (loading) {
      findList(current.id)
        .then((r) => {
          setUrls(r.data.contact_list_profile?.urls_used);
        })
        .finally(() => setLoading(false));
    }
  }, [current.id, loading]);

  return (
    <>
      {isDatabase ? (
        <Button
          onClick={() => {
            open();
            setLoading(true);
          }}
          leftSection={<IconHistory size={18} />}
          color="primary"
          variant={"subtle"}
          justify="start"
        >
          {lang.contact_lists.url_used.label_database}
        </Button>
      ) : (
        <Button
          onClick={() => {
            open();
            setLoading(true);
          }}
          leftSection={<IconLink size={18} />}
          color="primary"
          variant={inList ? "light" : "subtle"}
          justify="start"
        >
          {lang.contact_lists.url_used.label}
        </Button>
      )}

      {opened && (
        <Modal
          opened={opened}
          size={"lg"}
          onClose={handleClose}
          title={
            <>
              {isDatabase
                ? lang.contact_lists.url_used.title_database
                : lang.contact_lists.url_used.dialog.title}{" "}
              <b>
                {current?.name} #{current.id}
              </b>
            </>
          }
        >
          <LoadingOverlay visible={loading} />
          <Stack gap={"xs"}>
            <Stack>
              {isDatabase ? (
                searchHistory.map((item) => (
                  <ArgumentsDatabase key={item.uniqid} item={item} isHistory />
                ))
              ) : urls?.length > 0 ? (
                urls?.map((url, index) => (
                  <Group key={index} wrap="nowrap">
                    <IconCircleFilled />
                    <Anchor href={url} target="_blank" truncate="end">
                      {url}
                    </Anchor>

                    <CopyButton value={url}>
                      {({ copied, copy }) => (
                        <Tooltip
                          label={
                            copied
                              ? lang.contact_lists.url_used.dialog.copy_success
                              : lang.contact_lists.url_used.dialog.copy
                          }
                          color={copied ? "green" : "black"}
                        >
                          <ActionIcon
                            size={"lg"}
                            variant="light"
                            color={copied ? "green" : "primary"}
                            onClick={copy}
                          >
                            {copied ? (
                              <IconCheck size={20} />
                            ) : (
                              <IconCopy size={20} />
                            )}
                          </ActionIcon>
                        </Tooltip>
                      )}
                    </CopyButton>
                  </Group>
                ))
              ) : (
                <Text fontSize={16} c={"dimmed"} ta={"center"}>
                  {lang.contact_lists.url_used.dialog.no_links}
                </Text>
              )}
            </Stack>

            <Group justify="end" mt={"md"}>
              <BackButton onClick={handleClose} size="md" />
            </Group>
          </Stack>
        </Modal>
      )}
    </>
  );
};

export default ListUrlUsed;
